import Barba from 'barba.js';
import { $document, $html, $body, $window } from '../../utils/environment';

const DefaultTransition = Barba.BaseTransition.extend({
    start() {
        // lancement de la transition
        $body.addClass('is-navigation-categories-transition');
        $body.removeClass('is-loaded');

        // chargement du nouveau conteneur
        setTimeout(() => {
            this.newContainerLoading.then(this.finish.bind(this));
        }, 1400);
    },

    finish() {
        // transition terminée (callback)
        this.done();

        // setTimeout(() => {
            // reinit has-header-* classes and active navigation categories classes
            $document.trigger({
                type: 'rebuild.HeaderCategories',
            });

            // réinitialisation des modules dans le container
            $document.trigger({
                type: 'initModules.App',
                firstBlood: false
            });

            // reinit the fired item
            $document.trigger({
                type: 'reinitFired.HeaderCategories',
            });

            // suppression de la classe de transition
            $body.removeClass('is-navigation-categories-transition').addClass('is-loaded');
        // }, 2000);
    }
});

export default DefaultTransition;
